import { createContext, useContext } from 'react';
import { useBackNavigationLayer } from './navigation';

const MODAL_BASE_Z = 50;
const MODAL_Z_STEP = 10;

export const LayerDepthContext = createContext(0);

export interface ModalLayer {
  depth: number;
  zIndex: number;
  style: React.CSSProperties;
  onClose: () => void;
}

interface UseModalLayerOptions {
  enabled: boolean;
  onClose: () => void;
  historyState?: Record<string, unknown>;
  /** Set to false for modals that handle their own back-navigation or have none. Default true. */
  backNavigation?: boolean;
}

export function useModalLayer(options: UseModalLayerOptions): ModalLayer {
  const parentDepth = useContext(LayerDepthContext);
  const depth = parentDepth + 1;
  const zIndex = MODAL_BASE_Z + depth * MODAL_Z_STEP;

  const handleClose = useBackNavigationLayer({
    enabled: (options.backNavigation !== false) && options.enabled,
    onBack: options.onClose,
    state: options.historyState,
  });

  return {
    depth,
    zIndex,
    style: { zIndex } as React.CSSProperties,
    onClose: options.backNavigation !== false ? handleClose : options.onClose,
  };
}
